import * as G6 from '@antv/g6';

import Target from 'dashboard/components/GraphCanvasV2/target/target';

export default class SelectionBoxTarget extends Target<G6.IShape> {
  type = 'selection-box';
}
